import { ColumnType } from "../../types/dataGridTypes";

const useReportsColumns = () => {
  const reportsListColumns: ColumnType[] = [
    {
      field: "id",
      headerName: "Report ID",
      minWidth: 120,
      flex: 1,
      cmp: "link",
      linkPermission: "VIEW_STUDY_DETAILS",
      badge: true,
    },
    {
      field: "accessionid",
      headerName: "Accession ID",
      width: 160,
    },
    {
      field: "sampleid",
      headerName: "Sample ID",
      width: 160,
    },
    {
      field: "date",
      headerName: "Date",
      width: 120,
    },
    {
      field: "reporter",
      headerName: "Reporter",
      minWidth: 120,
      flex: 1,
    },
    {
      field: "pdf",
      headerName: "PDF",
      minWidth: 80,
      cmp: "icon",
      iconName: "AttachFile",
    },
    {
      field: "actionsColumn",
      width: 90,
      type: "actions",
      cmp: "actions",
      headerName: "Action",
      sortable: false,
      filterable: false,
      actionsArray: [
        { icon: "Edit", label: "Edit", key: "action_edit" },
        { icon: "Delete", label: "Delete", key: "action_delete" },
      ],
    },
  ];
  return reportsListColumns;
};

export default useReportsColumns;
